import { ThemeProperties } from '../../../core';

export interface InputPhoneNumberTheme {
	countrySelectTriggerHoverBg: string;
	countrySelectTriggerActiveBg: string;
}
export const theme = new ThemeProperties('inputPhoneNumber');
